export const CLASS_NAME = {
    id: 'className',
    name: 'All classes'
};
export const GROUP_NAME = {
    id: 'groupName',
    name: 'Groups'
};
export const COMPLETED_QUESTS_SUMMARY = {
    id: 'completedQuestsSummary',
    name: 'Progress through Standards'
};
export const ASSIGNED_QUESTS = {
    id: 'learningJourneysAssignedOrInProgressCount',
    name: 'ASSIGNED QUESTS'
};
export const COMPLETED_QUESTS = {
    id: 'learningJourneysCompletedCount',
    name: 'COMPLETED QUESTS'
};
export const STANDARDS_IN_PROGRESS = {
    id: 'standardsInProgressCount',
    name: 'STANDARDS IN PROGRESS'
};
export const STANDARDS_COMPLETED = {
    id: 'standardsCompletedCount',
    name: 'STANDARDS COMPLETED'
};
export const STUDENT_FULL_NAME = {
    id: 'fullName'
};

export const SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS = {
    CLASS_GROUP_LEVEL: 1,
    STUDENT_PROGRESS: 2,
    STUDENT_ACCURACY: 3
};

export const ASSIGNMENT_STATUSES = {
    NOT_ASSIGNED: 0,
    ASSIGNED: 1,
    IN_PROGRESS: 2,
    COMPLETED: 3
};

export const SQ_STANDARDS_COUNT_BOX_TYPES = {
    STANDARDS: 'STANDARDS',
    SKILL_QUESTS: 'SKILL_QUESTS',
    AVERAGE_ACCURACY: 'AVERAGE_ACCURACY',
    HIGHEST_ACCURACY: 'HIGHEST_ACCURACY'
};

export const EMPTY_CELL = '-';



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/skill-quests-mastery-constants.js